module.exports = __webpack_public_path__ + "img/icon_09.38fb4d71.svg";